import { render, staticRenderFns } from "@/components/Layout/Menu/Administracion/Administracion_camiones/Eliminar_camiones/Eliminar_camiones.html?vue&type=template&id=049b15e8&scoped=true&"
import script from "@/components/Layout/Menu/Administracion/Administracion_camiones/Eliminar_camiones/Eliminar_camiones.js?vue&type=script&lang=js&"
export * from "@/components/Layout/Menu/Administracion/Administracion_camiones/Eliminar_camiones/Eliminar_camiones.js?vue&type=script&lang=js&"
import style0 from "@/components/Layout/Menu/Administracion/Administracion_camiones/Eliminar_camiones/Eliminar_camiones.css?vue&type=style&index=0&id=049b15e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049b15e8",
  null
  
)

export default component.exports